import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_QUEUED_LETTERS',
    icon: 'MoreVerticalIcon',
    route: 'queued-letters',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
  },
]
